<div class="d-flex flex-row">
    <button
        type="button"
        class="campaign__action btn btn--paybee btn--outline-transparent caption dropdown-toggle"
        placement="bottom"
        [mdbPopover]="content"
        (popoverShown)="onPopoverShown()"
        (popoverHidden)="onPopoverHidden()"
        trigger="click"
        #popover="mdbPopover"
        style="border: 1px solid #D8D8D8; background: transparent; border-radius: 4px;"
    >
        <i class="fas fa-filter mr-2"></i>
        {{filterBtnText}}
    </button>
</div>



<ng-template #content >
    <div class="popover-links" style="width: 300px; max-height:400px; overflow:scroll">
        <div  class="popover__action d-flex align-items-center cursor-pointer px-3 body-1 default" [ngClass]="activeItem == 1 ? 'active' : ' ' " (click)="onCategoryClick('All', 1, '')">
            All
        </div>
        @for(category of categories; track category; let index = $index) {
            <div class="popover__action d-flex align-items-center cursor-pointer px-3 body-1 default" [ngClass]="activeItem == index + 2 ? 'active' : ' ' " (click)="onCategoryClick(category, index + 2, category.type)">
                {{category.name}}
            </div> 
        }
    </div>
</ng-template>